export const MAINTENANCE_NOTICE_STORAGE_KEY = "formula-ae-maintenance-notice-20260813/v1";

// 2026年8月12日 00:00から8月14日 00:00まで（日本標準時）。
const NOTICE_START_MS = Date.UTC(2026, 7, 11, 15, 0, 0);
const NOTICE_END_MS = Date.UTC(2026, 7, 13, 15, 0, 0);

type NoticeStorage = Pick<Storage, "getItem" | "setItem">;

export function isMaintenanceNoticePeriod(now: Date): boolean {
  const time = now.getTime();
  return Number.isFinite(time) && time >= NOTICE_START_MS && time < NOTICE_END_MS;
}

export function shouldShowMaintenanceNotice(now: Date, storage: NoticeStorage): boolean {
  if (!isMaintenanceNoticePeriod(now)) return false;
  try {
    return storage.getItem(MAINTENANCE_NOTICE_STORAGE_KEY) !== "acknowledged";
  } catch {
    // A storage policy must not prevent the time-sensitive notice from appearing.
    return true;
  }
}

export function acknowledgeMaintenanceNotice(storage: NoticeStorage): boolean {
  try {
    storage.setItem(MAINTENANCE_NOTICE_STORAGE_KEY, "acknowledged");
    return true;
  } catch {
    return false;
  }
}
